(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trade-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var sel = document.getElementById('trade-buyer-type');
    document.querySelectorAll('.trade__link[data-seg]').forEach(function (a) {
      a.addEventListener('click', function () {
        if (!sel) return;
        var want = a.getAttribute('data-seg');
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].value === want || sel.options[i].text === want) { sel.selectedIndex = i; break; }
        }
        var first = document.querySelector('#trade-enquiry input, #trade-enquiry select');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
      });
    });
    var sticky = document.getElementById('trade-sticky');
    var formBlock = document.getElementById('trade-enquiry');
    if (sticky && formBlock && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-hidden', entries[0].isIntersecting);
      }, { threshold: 0.15 });
      io.observe(formBlock);
    }
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();
})();
